import { render } from "./DomainSelection.vue?vue&type=template&id=0424837d&scoped=true"
import script from "./DomainSelection.vue?vue&type=script&lang=js"
export * from "./DomainSelection.vue?vue&type=script&lang=js"

import "./DomainSelection.vue?vue&type=style&index=0&id=0424837d&scoped=true&lang=css"

import exportComponent from "/Users/savvy/workspace/innotrail/MentoTestUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0424837d"]])

export default __exports__